<div class="profile-container">
  <div class="profile-image">
    <img [src]="userProfile?.photo" alt="Imagen principal" onerror="this.onerror=null; this.src='usuario.webp';">
  </div>
  <div class="profile-details">
    <h2>{{ userProfile?.name ? userProfile.name : 'Nombre no disponible' }}</h2>
    <p><strong>CC:</strong> {{ userProfile?.id ? userProfile.id : 'N/A' }}</p>
    <p><strong>Cargo:</strong> {{ userProfile?.role ? userProfile.role : 'N/A' }}</p>
  </div>
</div>
